import { GroupLabelProps } from './types';

type Props = Pick<GroupLabelProps, 'value' | 'label'>;

export const DefaultGroupLabel = ({ value, label }: Props) => {
  return label ?? value;
};
